'use strict';

exports.__esModule = true;

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _reactRouter = require('react-router');

var _reduxSimpleAuth = require('redux-simple-auth');

var LogoutPage = function LogoutPage(props) {
	if (typeof window !== 'undefined') {
		props.sessionActions.invalidateSession();
		if (!props.isAuthenticated) {
			_reactRouter.browserHistory.push('/login');
		}
	}
	/**
 	React doesn't want component to return undefined.
 **/
	return null;
};

LogoutPage.displayName = 'LogoutPage';

LogoutPage.defaultProps = {};

var mapStateToProps = function mapStateToProps(state) {
	return {
		isAuthenticated: (0, _reduxSimpleAuth.getIsAuthenticated)(state)
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return {
		sessionActions: (0, _redux.bindActionCreators)({ invalidateSession: _reduxSimpleAuth.invalidateSession }, dispatch)
	};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LogoutPage);


// WEBPACK FOOTER //
// ./components/logout-page/lib/components/logout-page.js